import styled from 'styled-components';

const ImagePicker = styled.div`
  position: relative;
  ._dark & {
    .form-item-options {
      li.active::before {
        background-image: url(${require('../images/check-on-client.png')});
      }
    }
  }

  &.is-slide {
    margin-bottom: 0;
    .form-item-options {
      position: relative;
      z-index: 2;
      width: 312px;
      margin: auto;
      padding: 0;
      &::-webkit-scrollbar-thumb {
        background: transparent;
      }
      ul {
        padding-bottom: 0;
      }
      li {
        min-height: 10px;
        span {
          color: #ffffff;
          white-space: nowrap;
        }
      }
    }
  }
  &.disabled .form-item-options li {
    cursor: not-allowed;
  }
  .form-item-nav {
    position: absolute;
    left: 52px;
    top: 50%;
    transform: translateY(-50%);
    width: 380px;
    display: flex;
    justify-content: space-between;

    li {
      cursor: pointer;
      font-size: 24px;
    }

    .disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
  .form-item-options {
    overflow-y: hidden;
    ul {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: nowrap;
      padding-bottom: 10px;
    }

    li {
      position: relative;
      margin-right: 12px;
      text-align: center;
      cursor: pointer;

      &.active {
        &::before {
          position: absolute;
          right: 6px;
          top: 6px;
          content: '';
          display: block;
          width: 20px;
          height: 20px;
          background: url(${require('../images/check-on.png')}) no-repeat center /
            contain;
        }
      }
    }

    img {
      width: 96px;
      height: 96px;
      border-radius: 8px;
    }

    span {
      margin-top: 8px;
      font-size: 12px;
      font-weight: 500;
      color: #333333;
    }
  }
`;

export default {
  ImagePicker,
};
